module.exports = __webpack_public_path__ + "media/flags/kz-8ad451f1.svg";